module.exports = __webpack_public_path__ + "img/engagement_rings@2x.2ef1416.jpg";